import Button, { ButtonVariants } from '~/components/atoms/Button/Button'
import Container from '~/components/atoms/Container/Container'
import Fixture from '~/components/atoms/Fixture/Fixture'
import { Col, Grid, Row } from '~/components/atoms/Grid'
import type { IconWithTextProps } from '~/components/atoms/IconWithText/IconWithText'
import IconWithText from '~/components/atoms/IconWithText/IconWithText'
import Text, { TextSizes } from '~/components/atoms/Text/Text'
import type { LinkProps } from '~/components/links'
import { resolveLink } from '~/components/serializers'
import { ComponentTheme } from '~/components/themes'

import styles from './IconWithTextGroup.module.css'
export interface IconWithTextGroupProps {
  title?: string
  items: IconWithTextProps[]
  theme?: ComponentTheme
  verticalPadding?: boolean
  noPaddingBottom?: boolean
  testID?: string
  link?: LinkProps
  moduleId?: string
  summary?: string
}

export default function IconWithTextGroup({
  title,
  items,
  theme = ComponentTheme.primary,
  verticalPadding,
  noPaddingBottom,
  testID,
  link,
  moduleId,
  summary,
}: IconWithTextGroupProps) {
  return (
    <Fixture
      theme={theme}
      verticalPadding={verticalPadding}
      noPaddingBottom={noPaddingBottom}
      id={moduleId}
    >
      <Container>
        <div className={styles.base} data-testid={testID}>
          <div className={styles.titleContainer}>
            {title && (
              <Text
                size={TextSizes.primaryTitleLrgPlus}
                Tag="h3"
                className={styles.title}
              >
                <span dangerouslySetInnerHTML={{ __html: title }} />
              </Text>
            )}
            {summary && (
              <Text
                size={TextSizes.bodyMed}
                Tag="h3"
                className={styles.summary}
              >
                {summary}
              </Text>
            )}
          </div>
          <Grid>
            <Row>
              {items.map((item: IconWithTextProps) => (
                <Col variant="col-1/3--md" key={item.text}>
                  <IconWithText {...item} className={styles.item} />
                </Col>
              ))}
            </Row>

            {link?.text && (
              <Row>
                <Col cssClass={styles.groupCta}>
                  <Button
                    iconLeft={true}
                    link={resolveLink(link)}
                    variant={ButtonVariants.primaryDark}
                    testID={testID}
                    launchForm={link.launchForm}
                    gaTrack={link.gaTrack}
                    gaTrackEventName={link.gaTrackEventName}
                    phCTASource={link?.phCTASource}
                    phEventName={link?.phEventName}
                    phInteractionLocation={link?.phInteractionLocation}
                    phWebProduct={link?.phWebProduct}
                  >
                    {link.text}
                  </Button>
                </Col>
              </Row>
            )}
          </Grid>
        </div>
      </Container>
    </Fixture>
  )
}
